import momentJalaali from "moment-jalali";
import Loader from "react-loader-spinner";
import { useDispatch } from "react-redux";
import { Fragment, useEffect, useState } from "react";
import icons8 from "../content/images/icons8-go-back-24.png";
import backWhite from "../content/images/icons8-go-back-White.png";
import { useHistory, useLocation, useParams } from "react-router-dom";
import "../Css/Stimulsoft/stimulsoft.viewer.office2013.lightgrayblue.css";
import "../Css/Stimulsoft/stimulsoft.designer.office2013.lightgrayblue.css";
import { savePrintReport, loadPrintReport, loadPrintDataSource_get, loadPrintDataSource_post } from "../store/api/CommonFunctions";


const PrintViewer = () => {

    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();
    const dataUrlInfo = location.state;
    const [pending, setPending] = useState(false);
    const { reportName, designMode } = useParams();
    const company = JSON.parse(localStorage.getItem("Company"));
    const report = new window.Stimulsoft.Report.StiReport();
    report.info.zoom = 1.1;


    const setReportData = (jsonData) => {


        let varNow = new window.Stimulsoft.Report.Dictionary.StiVariable();
        varNow.name = "CurrentDate";
        varNow.alias = "تاریخ امروز";
        varNow.Type = window.Stimulsoft.System.StimulsoftType;
        varNow.requestFromUser = false;
        varNow.value = momentJalaali().format('jYYYY/jM/jD');
        report.dictionary.variables.add(varNow);
        let varAddress = new window.Stimulsoft.Report.Dictionary.StiVariable();
        varAddress.name = "CompanyAddress";
        varAddress.alias = "آدرس شرکت";
        varAddress.Type = window.Stimulsoft.System.StimulsoftType;
        varAddress.requestFromUser = false;
        varAddress.value = company?.CompanyAddress;
        report.dictionary.variables.add(varAddress);
        let varName = new window.Stimulsoft.Report.Dictionary.StiVariable();
        varName.name = "CompanyName";
        varName.alias = "نام شرکت";
        varName.Type = window.Stimulsoft.System.StimulsoftType;
        varName.requestFromUser = false;
        varName.value = company?.CompanyName;
        report.dictionary.variables.add(varName);
        var varTel = new window.Stimulsoft.Report.Dictionary.StiVariable();
        varTel.name = "CompanyPhone";
        varTel.alias = "تلفن شرکت";
        varTel.Type = window.Stimulsoft.System.StimulsoftType;
        varTel.requestFromUser = false;
        varTel.value = company?.Phone;
        report.dictionary.variables.add(varTel);
        var fileContent = window.Stimulsoft.System.IO.File.getFile("../content/font/Vazir.ttf", true);
        var resource = new window.Stimulsoft.Report.Dictionary.StiResource(
            "Vazir", "Vazir", false, window.Stimulsoft.Report.Dictionary.StiResourceType.FontTtf, fileContent);
        report.dictionary.resources.add(resource)
        const dataSet = new window.Stimulsoft.System.Data.DataSet("ds" + reportName);
        dataSet.readJson(JSON.stringify(jsonData));
        report.regData("ds" + reportName, "ds" + reportName, dataSet);
        report.dictionary.synchronize();
        setPending(false);
        report.reportAlias = reportName;
        if (!designMode || designMode.toLowerCase() === "false") {
            const viewOptions = new window.Stimulsoft.Viewer.StiViewerOptions();
            viewOptions.appearance.fullScreenMode = true;
            viewOptions.appearance.scrollbarsMode = true;
            viewOptions.toolbar.showViewModeButton = true;
            viewOptions.toolbar.printDestination = window.Stimulsoft.Viewer.StiPrintDestination.Direct;
            const viewer = new window.Stimulsoft.Viewer.StiViewer(viewOptions, "StiViewer", false);
            viewer.report = report;
            viewer.renderHtml("printDesigner");
            var userButton = viewer.jsObject.SmallButton("userButton", "بازگشت", "emptyImage");
            userButton.style["font-family"] = "Vazir";
            userButton.style["color"] = "blue";
            userButton.image.src = icons8;
            userButton.action = function () { history.goBack() }

            var toolbarTable = viewer.jsObject.controls.toolbar.firstChild.firstChild;
            var buttonsTable = toolbarTable.rows[0].firstChild.firstChild;
            var userButtonCell = buttonsTable.rows[0].insertCell(0);
            userButtonCell.className = "stiJsViewerClearAllStyles";
            userButtonCell.appendChild(userButton);
        }
        else if (designMode.toLowerCase() === "true") {
            const options = new window.Stimulsoft.Designer.StiDesignerOptions();
            options.appearance.fullScreenMode = true;
            options.appearance.htmlRenderMode = window.Stimulsoft.Report.Export.StiHtmlExportMode.Div;
            const designer = new window.Stimulsoft.Designer.StiDesigner(options, "Designer", false);
            designer.onSaveReport = function (e) {
                const jsonStr = e.report.saveToJsonString();
                savePrintReport(reportName, jsonStr);
            }
            designer.report = report;
            designer.renderHtml("printDesigner");
            designer.jsObject.options.images["ImageBack"] = backWhite;
            var toolBarRow = designer.jsObject.options.toolBar.firstChild.tr[0];
            var customButton = designer.jsObject.StatusPanelButton("btnBack", "بازگشت", "ImageBack", null, null, 30, 30);
            customButton.action = function () { history.goBack() }
            customButton.style["font-family"] = "Vazir";
            customButton.style["color"] = "white";
            var buttonCell = document.createElement("td");
            buttonCell.className = "stiDesignerToolButtonCell";
            buttonCell.appendChild(customButton);
            toolBarRow.insertBefore(buttonCell, toolBarRow.childNodes[0]);

        }
    }
    const print = (res) => {
        setPending(true);
        report.load(res);
        if (dataUrlInfo.method === "get") {
            dispatch(loadPrintDataSource_get(dataUrlInfo.dataUrl, setReportData));
        }
        else if(dataUrlInfo.method === "post")
        {
            dispatch(loadPrintDataSource_post(dataUrlInfo.dataUrl, dataUrlInfo.fetchBody,setReportData));
        }


    }
    useEffect(() => {
        document.body.classList = "notMain";
        loadPrintReport(reportName, print);

    }, [])
    return (
        <div id="printDesigner" style={{ direction: "ltr" }}>
            {pending && 
            <Fragment>
                <div>&nbsp;</div>
            <Loader type="BallTriangle" color="#bb1370" height={40} width={40} />
            </Fragment>
            }
        </div>
    )
}
export default PrintViewer;